(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/views/betslip.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/views/betslip.js');

'use strict';

svs.lotto.components.play.views.Betslip = Marionette.View.extend({
  viewOptions: ['showJoker', 'showDrawCount', 'showParticipation', 'showAccountSelector', 'showSubscriptionInfo'],
  showJoker: true,
  showDrawCount: true,
  showParticipation: true,
  showAccountSelector: true,
  showSubscriptionInfo: true,
  className: 'numbergames-footer col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4',
  regions: {
    drawDaysRegion: '#drawDaysRegion',
    participationRegion: '#participationRegion',
    jokerRegion: '#jokerRegion',
    drawCountRegion: '#drawCountRegion',
    subscriptionInfoRegion: '#subscriptionInfoRegion',
    accountSelectorRegion: '#accountSelectorRegion',
    trissRegion: '#trissRegion'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.game.behaviors.teamSelectorAndSubscriptionInfo,
    subscriptionInfoRegionSelector: 'subscriptionInfoRegion',
    accountSelectorRegionSelector: 'accountSelectorRegion'
  }],
  template(data) {
    return svs.lotto.components.play.templates.betslip(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    var _this$model$get;
    const rules = svs.numbergames.rules.getRules({
      productId: svs.numbergames.productMapping.CONSTANTS.LOTTO
    });
    this.showChildView('drawDaysRegion', new svs.numbergames.game.views.DrawDays({
      model: this.model
    }));
    if (this.showParticipation) {
      this.showChildView('participationRegion', new svs.numbergames.game.views.PartDraw({
        model: this.model
      }));
    }
    if (this.showJoker) {
      this.showChildView('jokerRegion', new svs.numbergames.game.views.Joker({
        model: this.model
      }));
    }
    if (this.showDrawCount) {
      this.showChildView('drawCountRegion', new svs.numbergames.game.views.DrawCount({
        model: this.model,
        drawCountHeader: 'Spellängd',
        possibleDrawCounts: [...rules.possibleDrawCounts],
        hasSubscription: !svs.core.config.data.svsconfig.isSelfService
      }));
    }
    if ((_this$model$get = this.model.get('tickets')) !== null && _this$model$get !== void 0 && (_this$model$get = _this$model$get.at(0)) !== null && _this$model$get !== void 0 && _this$model$get.get('ticketData')) {
      this.showChildView('trissRegion', new svs.numbergames.game.views.Triss({
        model: this.model,
        productId: this.model.get('productId')
      }));
    }
  }
});

 })(window);